import afinn from "./afinn";
import SentimentResult from "../models/SentimentResult";

const tokenize = (phrase) => {
  return phrase
    .replace(/[^a-zA-Z ]+/g, " ")
    .replace("/ {2,}/", " ")
    .toLowerCase()
    .split(" ");
};

function wordCount(words) {
  return words.reduce(
    (result, word) =>
      Object.assign(result, {
        [word]: result[word] ? result[word] + 1 : 1,
      }),
    {}
  );
}

/* eslint-disable no-param-reassign */
const tally = (tokens, positive) => {
  return positive
    ? tokens.reduce(
        (result, token) => {
          if (afinn[token] && afinn[token] > 0) {
            result.words.push(token);
            result.hits += afinn[token];
          }
          return result;
        },
        { words: [], hits: 0 }
      )
    : tokens.reduce(
        (result, token) => {
          if (afinn[token] && afinn[token] < 0) {
            result.words.push(token);
            result.hits -= afinn[token];
          }
          return result;
        },
        { words: [], hits: 0 }
      );
};

function negativity(phrase) {
  const tokens = tokenize(phrase);
  const { words, hits } = tally(tokens, false);
  return {
    score: hits,
    comparative: hits / words.length,
    words,
  };
}

function positivity(phrase) {
  const tokens = tokenize(phrase);
  const { words, hits } = tally(tokens, true);
  return {
    score: hits,
    comparative: hits / words.length,
    words,
  };
}

function analyze(phrase) {
  const positive = positivity(phrase);
  const negative = negativity(phrase);
  return new SentimentResult({
    score: positive.score - negative.score,
    positiveWords: wordCount(positive.words),
    negativeWords: wordCount(negative.words),
  });
}

export default analyze;
